export default __webpack_public_path__ + "static/media/gdeli.dbb2f4f6.png";